module.exports = __webpack_public_path__ + "static/img/pm2-mark.5120c68.png";